import { gtmService } from '@utils/gtm';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook for Google Tag Manager integration
 */
export const useGTM = () => {
    const location = useLocation();

    // Track page views automatically on route changes
    useEffect(() => {
        if (gtmService.isReady()) {
            gtmService.trackPageView(location.pathname);
        }
    }, [location.pathname]);

    const trackEvent = useCallback((...args: Parameters<typeof gtmService.trackEvent>) => {
        gtmService.trackEvent(...args);
    }, []);

    const trackFormSubmission = useCallback((...args: Parameters<typeof gtmService.trackFormSubmission>) => {
        gtmService.trackFormSubmission(...args);
    }, []);

    const trackDownload = useCallback((...args: Parameters<typeof gtmService.trackDownload>) => {
        gtmService.trackDownload(...args);
    }, []);

    const trackEngagement = useCallback((...args: Parameters<typeof gtmService.trackEngagement>) => {
        gtmService.trackEngagement(...args);
    }, []);

    const trackCustomEvent = useCallback((...args: Parameters<typeof gtmService.sendEvent>) => {
        gtmService.sendEvent(...args);
    }, []);

    return {
        trackEvent,
        trackFormSubmission,
        trackDownload,
        trackEngagement,
        trackCustomEvent,
        isReady: gtmService.isReady(),
    };
};

export default useGTM;
